// IMPORTANT! Use unique keys for store inside producer app

export const PICKUPS_SIGN_IN = 'PICKUPS_SIGN_IN';
export const PICKUPS_SIGN_OUT = 'PICKUPS_SIGN_OUT';
export const PICKUPS_SET_USER_OBJECT = 'PICKUPS_SET_USER_OBJECT';
export const PICKUPS_MAKE_INITIALIZED = 'PICKUPS_MAKE_INITIALIZED';
export const PICKUPS_MAKE_NON_INITIALIZED = 'PICKUPS_MAKE_NON_INITIALIZED';
export const PICKUPS_CHANGE_LOADING = 'PICKUPS_CHANGE_LOADING';
